// Emoji in files causes Chrome to not link files in workspace properly
// Please put every emojis here to keep other files emoji-free
var EmojiMap = {
  "no_entry_sign"         : "🚫",
  "ok_hand"               : "👌",
  "paperclip"             : "📎",
  "red_circle"            : "🔴",
  "slightly_smiling_face" : "🙂",
  "unicorn_face"          : "🦄",
  "wave"                  : "👋",
  "sunglasses"            : "😎",
  "smile"                 : "😄",
  "simple_smile"          : "🙂",
  "stuck_out_tongue"      : "😛",
  "disappointed"          : "🙁",
  "-1"                    : "👎",
  "+1"                    : "👍",
  "heart"                 : "❤️",
  "rocket"                : "🚀"
};
